import {put,takeLatest,call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";

import {
    GET_TABLE,
    GET_TABLE_SUCCESS,
    GET_TABLE_ERROR
}
    from "../../actions/table";

function* getTableSaga(action) {
    try {
        const data=yield call(tableService.GetTable,action.payload)
        yield put({
            type: GET_TABLE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_TABLE_ERROR,error: error.data
        });
    }
}


export function* getTableSagaWatcher() {
    yield takeLatest(GET_TABLE,getTableSaga);
}